// extracted by mini-css-extract-plugin
export default {"pdf_icon":"styles_pdf_icon__k5wVJ","speech_started":"styles_speech_started__Ol+0r"};